import React, { Fragment, useEffect } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const RevenueWall = ({})=> {

  const currentUser = security.currentUserValue;
  const app         = 'OCXA-d7b61754-94a2-47f8-ae33-66b425ec3318';

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/surveys" />

      <iframe
        width="100%"
        frameBorder={0}
        height={2000}
        src={`https://surveys.revenuewall.com/begin?app=${app}&spv1=${currentUser.id}`}
      ></iframe>

    </Fragment>
  );
};

export default RevenueWall;
